import Image from 'next/image';

import { ContentType } from '../../../types/content';

export function HeaderContainer(props: ContentType) {
  const { description, src, title } = props;

  return (
    <div className="flex flex-col w-full">
      <div className="w-full">
        <Image
          alt="Header Image"
          blurDataURL="/icons/blur-placeholder.png"
          height={'30vh'}
          layout="responsive"
          placeholder="blur"
          priority
          src={src as string}
          width={'100vw'}
        />
      </div>

      <header className="flex flex-col items-center justify-center py-8 xl:py-16 space-y-4 text-center bg-headerBackground h-56 max-h-56 sm:h-44 sm:max-h-44 lg:h-52 lg:max-h-52">
        <h4 className="text-header6 md:text-2header4 uppercase font-ChronicleDisplaySemibold px-5">
          {title}
        </h4>
        <p className="font-extralight text-subtitle tracking-wide px-12 lg:px-48">
          {description}
        </p>
      </header>
    </div>
  );
}

export default HeaderContainer;
